module.exports = __webpack_public_path__ + "static/media/desktopScreenshot03.d695e607.jpg";